import React from "react";
import BuyingGuideProConListContentTypes from "../Types/BuyingGuideProConListContentTypes";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";

export default function BuyingGuideProAndConList({
  section,
}: {
  section: BuyingGuideSection;
}) {
  const { contents } = section;

  const headingContent = contents.find(
    (content) =>
      content.listType === BuyingGuideProConListContentTypes.Description,
  );

  const proContent = contents.find(
    (content) => content.listType === BuyingGuideProConListContentTypes.Pro,
  );

  const conContent = contents.find(
    (content) => content.listType === BuyingGuideProConListContentTypes.Con,
  );

  return (
    <div className="guide-section">
      <div className="pros-cons">
        {headingContent?.imageUrl && (
          <div className="pros-cons__img">
            <img
              src={headingContent?.imageUrl}
              alt={headingContent?.imageAlternateText}
            />
          </div>
        )}
        <div className="pros-cons__content">
          {headingContent?.imageUrl && (
            <div className="pros-cons__img pros-cons__img--mobile">
              <img
                src={headingContent?.imageUrl}
                alt={headingContent?.imageAlternateText}
              />
            </div>
          )}
          {(headingContent?.heading || headingContent?.htmlContent) && (
            <div className="pros-cons__text">
              {headingContent?.heading && (
                <div
                  className="pros-cons__title"
                  dangerouslySetInnerHTML={{
                    __html: headingContent.heading,
                  }}
                />
              )}
              {headingContent?.htmlContent && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: headingContent.htmlContent,
                  }}
                />
              )}
            </div>
          )}
          <div className="pros-cons__comparison">
            <div className="pros-cons__table pros-cons__table--pro">
              <div className="pros-cons__title">Pros</div>
              <ul className="highlights">
                {proContent?.listItems.map((item, index) => (
                  <li className="icon-check" key={`pro-${index}`}>
                    {item.listItemContent}
                  </li>
                ))}
              </ul>
            </div>
            <div className="pros-cons__table pros-cons__table--con">
              <div className="pros-cons__title">Cons</div>
              <ul className="highlights">
                {conContent?.listItems.map((item, index) => (
                  <li className="icon-cancel" key={`con-${index}`}>
                    {item.listItemContent}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
